import { RouteRecordRaw } from 'vue-router';
import { OperationLogsPage } from '@/pages/operation-logs';

export const routeName = 'LogsOperacoes';

export const route: RouteRecordRaw = {
  path: 'logs-operacoes',
  name: routeName,
  component: OperationLogsPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Logs de Operações',
    permissions: [{ action: 'manage', subject: 'OperationLog' }],
  },
};
